import { useLoadScript } from '@react-google-maps/api';

const googleMapsApiKey =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_GMAP_API_KEY_DEV ?? ''
    : process.env.REACT_APP_GMAP_API_KEY ?? '';

export const useLoadGoogleMaps = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey,
    region: 'JP',
    language: 'ja',
  });

  return { isLoaded, loadError };
};
